// extracted by mini-css-extract-plugin
module.exports = {"profile-layout":"panel_profile-layout__s5z7f","menu-layout":"panel_menu-layout__o2cOf","content-layout":"panel_content-layout__OEeuY","full-width":"panel_full-width___SG4C"};